import { gql } from "@apollo/client";

export const GET_TICKETS_QUERY = gql`
  query Tickets {
    tickets(status: null, category: null) {
      id
      short_code
      parent_ticket
      company_id
      created_by
      title
      description
      priority
      category
      sub_category
      status
      estimated_time
      start_date
      end_date
      ticketComments {
            count
        }
      assigned_to {
        id
        firstName
        lastName
        fullName
      }
      assigned_by {
        id
        firstName
        lastName
        fullName
      }
      assigned_at
      resolved_at
      closed_at
      created_at
      updated_at
      deleted_at
    }
  }
`;

// Ticket Comments Query (for specific ticket or all tickets when ticket_id is null)

export const GET_TICKET_COMMENTS_QUERY = gql`
  query TicketComments($ticket_id: ID!) {
    ticketComments(ticket_id: $ticket_id) {
      id
      ticket_id
      user_id
      user_schema
      user_name
      user_email
      comment
      created_at
      updated_at
      deleted_at
    }
  }
`;

// All Ticket Comments Query (fetch all comments for all tickets)
